module.exports = __webpack_public_path__ + "img/WordDownload.da8aa654.svg";